/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { WindowConstraints, WindowPosition, WindowSize } from "interfaces/windowSize.interface";

/**
 * Default configuration values for videochat window sizing and positioning.
 * Defines constraints, initial size, and initial position for draggable videochat window.
 */
export const VIDEOCHAT_WINDOW_DEFAULTS = {
    CONSTRAINTS: {
      minWidth: 500,
      minHeight: 600,
      maxWidth: 1920,
      maxHeight: 1080
    },
    SIZE: {
      width: 800,
      height: 700
    },
    POSITION: {
      x: 100,
      y: 100
    }
   } as const;